import { render, staticRenderFns } from "./FollowerList.vue?vue&type=template&id=5c70ca9e&"
import script from "./FollowerList.vue?vue&type=script&lang=js&"
export * from "./FollowerList.vue?vue&type=script&lang=js&"
import style0 from "./FollowerList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports